import type { UtmParams } from '../types/lead.js';

const EMPTY: UtmParams = {
  referrer: '',
  utm_source: '',
  utm_medium: '',
  utm_campaign: '',
  utm_term: '',
  utm_content: '',
};

/**
 * Parse UTM parameters and referrer from a query string + referrer value.
 * Pure function so it can be unit-tested without a DOM.
 */
export function parseUtm(search: string, referrer: string): UtmParams {
  const params = new URLSearchParams(search || '');
  const get = (k: string) => (params.get(k) || '').slice(0, 256);
  return {
    referrer: (referrer || '').slice(0, 512),
    utm_source: get('utm_source'),
    utm_medium: get('utm_medium'),
    utm_campaign: get('utm_campaign'),
    utm_term: get('utm_term'),
    utm_content: get('utm_content'),
  };
}

/** Capture UTM/referrer from the live browser environment. */
export function captureUtm(): UtmParams {
  if (typeof window === 'undefined') return { ...EMPTY };
  return parseUtm(window.location.search, document.referrer);
}
